export default {
  title: 'Detalles del pedido',
};
